/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react'
import { Icon20 } from 'builder/components/Icon'
import ActionMenu from 'builder/components/ActionMenu'
import { CategoryIds, useCategoryTabsContext } from '..'
import { TabItem, Container } from '../styles'

const wrapperStyles = {
  textAlign: 'center',
  width: 'auto',
  position: 'relative',
  maxWidth: '294px',
  minWidth: '220px',
} as const

export default function CategoryDropdown(props: {
  items: { id: CategoryIds; label: string; element: React.ReactNode }[]
}) {
  const [isOpen, setIsOpen] = React.useState(false)
  const { activeTab, setActiveTab } = useCategoryTabsContext()
  const activeItem = props.items.find(i => i.id === activeTab)

  const actions = props.items.map((child, i) => ({
    text: child.label,
    onClick: () => setActiveTab(child.id),
    divider: i !== 0,
    isActive: child.id === activeTab,
  }))

  return (
    <Container>
      <div style={wrapperStyles}>
        <TabItem isActive={isOpen} onClick={() => setIsOpen(!isOpen)}>
          {activeItem?.label}
          {isOpen ? <Icon20.ChevronUp /> : <Icon20.ChevronDown />}
        </TabItem>

        {isOpen && (
          <ActionMenu
            position="bottom"
            align="left"
            onClose={() => setIsOpen(false)}
            actions={actions}
          />
        )}
      </div>
    </Container>
  )
}
